export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens but unlike most Cosmos SDK chains, Osmosis has daily epochs and releases new tokens only at the end of each epoch. Users can withdraw or compound at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `Osmosis has an inflationary rewards policy used to incentivize OSMO holders to stake and provide liquidity. The inflation will be cut by 1/3 every year, starting from 300 million tokens released in the first year. This process will allow OSMO to reach an asymptotic max supply of 1 billion. Newly released tokens will be distributed to a combination of staking rewards (25%), liquidity mining incentives (25%), developer vesting (45%), and community pool (5%).`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 14 days unbonding period when unstaking OSMO from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns. Enabling auto-compound via REstake by Eco Stake is also an available option.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
